import React from '../../../node_modules/react'
import "./style.scss"
import { Link } from 'react-router-dom'

import Diamante from '../../assets/imagens/medalha-diamante.png'
import Ouro from '../../assets/imagens/medalha-ouro.png'
import Prata from '../../assets/imagens/medalha-prata.png'
import Bronze from '../../assets/imagens/medalha-bronze.png'
import Avaliacao from '../../assets/imagens/medalha-avaliacao.679d1f19.png'
import Inativa from '../../assets/imagens/Inativa-110x150px-EbitNielsen20-d01.png'

const MedalLink = () => {

  return (
    <>
      <div className="aboutUs-medal container">
        <h3>Medalhas</h3>
        <div className="aboutUs-medal__newMedals container">
          <div>
            <img src={Diamante} title="Medalha Diamante" alt="Medalha Diamante" />
          </div>
          <div>
            <img src={Ouro} title="Medalha Ouro" alt="Medalha Ouro" />
          </div>
          <div>
            <img src={Prata} title="Medalha Prata" alt="Medalha Prata" />
          </div>
          <div>
            <img src={Bronze} title="Medalha Bronze" alt="Medalha Bronze" />
          </div>
          <div>
            <img src={Avaliacao} title="Medalha Avaliação" alt="Medalha Avaliação" />
          </div>
          <div>
            <img src={Inativa} title="Medalha Inativa" alt="Medalha Inativa" />
          </div>
        </div>

        <div className="aboutUs-medal__button-newMedals">
          <Link to="/medalhas-ebit"><span>Clique aqui</span> para saber mais sobre as medalhas Ebit | Nielsen </Link>
        </div>

      </div>
    </>

  )
}

export default MedalLink






